<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="outsourcing-batch-import-dialog ah-detail-dialog"
        :width="fileName ? null : '400px'"
        top="10vh"
        :before-close="() => onClose()"
        :show-close="false"
        @open="onOpen"
    >
        <template slot="title">批次匯入客戶</template>
        <div class="detail-row">
            <uploadFileView v-if="!fileName" @updateSheet="onUpdateSheet" @updateFileName="onUpdateFileName" @import="onImport" @close="onClose" />
            <checkView v-else :sheetToImport="sheetToImport" />
        </div>
        <div class="detail-row footer right" v-if="fileName">
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <template v-if="importStatus === 'init'">
                    <div>
                        <el-button plain @click="onUpdateFileName(null)">重新上傳 Excel 檔案</el-button>
                        <el-button plain @click="onClose()">取消</el-button>
                    </div>
                    <div>
                        <el-button type="primary" @click="onImport">開始新增 {{ sheetToImport.length }} 筆資料</el-button>
                    </div>
                </template>
                <template v-else>
                    <div style="flex:0.9">
                        <el-progress :percentage="processPercentage" :color="processPercentage === 100 ? '#92DE56' : '#463cb2'"></el-progress>
                    </div>
                    <div v-if="importStatus === 'importing'">
                        <el-button :loading="isStopped" plain @click="onStop">
                            <span v-if="!isStopped">停止</span>
                            <span v-else>停止中</span>
                        </el-button>
                    </div>
                    <div v-else>
                        <el-button type="primary" @click="onClose(true)">完成</el-button>
                    </div>
                </template>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import uploadFileView from '@/components/dashboard/Vendor/BatchImportDialogViews/uploadFileView.vue';
import checkView from '@/components/dashboard/Vendor/BatchImportDialogViews/checkView.vue';
import clMap from '@/components/dashboard/Vendor/BatchImportDialogViews/labelFieldMap';
import { isGuiNumberValid } from 'taiwan-id-validator';

export default {
    name: 'payment-export-pdf-dialog',
    props: {
        visible: Boolean,
        data: {
            type: Object,
            default: () => {},
        },
    },
    components: { uploadFileView, checkView },
    data() {
        return {
            importStatus: 'init',
            isStopped: false,
            fileName: null,
            sheetToImport: [],

            processPercentage: 0,

            options_OS: [],
            options_VD: [],
        };
    },
    computed: {
        options() {
            return this.type === 'vd' ? this.options_VD : this.options_OS;
        },
    },
    methods: {
        onOpen() {
            this.fetchOptions();
            this.importStatus = 'init';
            this.isStopped = false;
            this.fileName = null;
            this.sheetToImport = [];
            this.processPercentage = 0;
        },
        onClose(refresh) {
            this.$emit('close', refresh);
        },
        async fetchOptions() {
            const resp = await this.$api({
                url: '/Tool/GetDepartmentAndVendorSettings',
                method: 'get',
            });

            this.options_OS = resp.data.vendorSettings_OS;
            this.options_VD = resp.data.vendorSettings_VD;
        },
        async onImport() {
            this.importStatus = 'importing';
            const TOTAL_LENGTH = this.sheetToImport.length;
            let currentProcessedDataCount = 0;

            // eslint-disable-next-line no-restricted-syntax
            for (const data of this.sheetToImport) {
                if (this.isStopped) break;
                try {
                    data.importStatus = 'importing';

                    currentProcessedDataCount += 1;
                    this.processPercentage = Math.round((currentProcessedDataCount / TOTAL_LENGTH) * 100);

                    // eslint-disable-next-line no-await-in-loop
                    await this.$api_silent({
                        url: 'VendorManagementPage/UpsertVendorDetail',
                        data: this.getMapData(data),
                        method: 'POST',
                    });

                    data.importStatus = '已新增';
                } catch (e) {
                    console.log(e);
                    if (!e.response) data.importStatus = e.msg;
                    else if (e.response.status === 400) data.importStatus = '缺少欄位';
                    else if (e.response.status === 500) data.importStatus = e.response.data;
                }
            }

            this.importStatus = 'complete';
        },
        onStop() {
            this.isStopped = true;
        },
        onUpdateSheet(sheet) {
            const SHEET = _.chain(sheet)
                .map((o) => _.mapKeys(o, (v, k) => k.replace('*', '').split(/\n|\r\n/)[0]))
                .map((o) => ({ ...o, importStatus: 'init' }))
                .value();
            console.log(SHEET);
            this.sheetToImport = SHEET;
        },
        onUpdateFileName(nam) {
            this.fileName = nam;
        },
        getMapData(o) {
            const COMMON_REQUIRE_FIELD_LIST = [clMap.fnam, clMap.nam];
            const FILED_WORD_LIMIT_MAP = [
                { field: clMap.fnam, limit: 50 },
                { field: clMap.bsn, limit: 20 },
                { field: clMap.adr, limit: 100 },
                { field: clMap.note, limit: 200 },
                { field: clMap.nam, limit: 30 },
                { field: clMap.job, limit: 20 },
                { field: clMap.tel, limit: 20 },
                { field: clMap.ext, limit: 10 },
                { field: clMap.eml, limit: 100 },
                { field: clMap.accountLast5Number, limit: 5 },
            ];

            this.checkValidData(o, COMMON_REQUIRE_FIELD_LIST, FILED_WORD_LIMIT_MAP);

            const DATA = {
                fnam: o[clMap.fnam],
                cnam: o[clMap.fnam],
                bsN_NO: o[clMap.bsn] ? 1 : 0,
                bsn: o[clMap.bsn] ? `${o[clMap.bsn]}` : '',
                adr: o[clMap.adr] ? `${o[clMap.adr]}` : '',
                bilL_DAY: this.getBillSooDay(o[clMap.bilL_DAY]),
                soO_DAY: this.getBillSooDay(o[clMap.soO_DAY]),
                note: o[clMap.note],
                adR_CODE: '',
                ara: '',
                cty: '',
                voo: '',
                vdR_TYP: 'CL',
                onf: 1,
                accountLast5Number: o[clMap.accountLast5Number] ? `${o[clMap.accountLast5Number]}` : '',
                vendorContacts: [
                    {
                        nam: o[clMap.nam] || '',
                        gen: !o[clMap.gen] || o[clMap.gen] === '先生' ? 0 : 1,
                        job: o[clMap.job] || '',
                        tel: o[clMap.tel] || '',
                        ext: o[clMap.ext] || '',
                        eml: o[clMap.eml] || '',
                        dep: '',
                    },
                ],
            };

            return DATA;
        },

        checkValidData(o, requireFieldList, fieldWordLimitMap) {
            // 檢查必填欄位
            requireFieldList.forEach((item) => {
                // eslint-disable-next-line no-throw-literal
                if (!o[item]) throw { msg: '缺少必填欄位，請檢查後重新上傳' };
            });

            // 檢查字數
            fieldWordLimitMap.forEach((item) => {
                // eslint-disable-next-line no-throw-literal
                if (o[item.field]?.length > item.limit) throw { msg: `「${item.field}」超過字數上限：${item.limit}` };
            });

            // eslint-disable-next-line no-throw-literal
            if (o[clMap.bsn] && !isGuiNumberValid(o[clMap.bsn])) throw { msg: '統一編號格式不正確' };
        },
        getBillSooDay(data) {
            if (!data || data === '無') return 0;
            return +data.replace('日', '');
        },
    },
};
</script>

<style lang="scss" scoped>
.outsourcing-batch-import-dialog.ah-detail-dialog {
    .detail-row {
        padding: 40px;
    }
    .el-progress__text {
        margin-left: 70px;
    }
}
</style>

<style lang="scss">
.outsourcing-batch-import-dialog {
    .el-progress__text {
        margin-left: 15px;
    }
}
</style>
